import React, { PureComponent } from 'react';
import styled from 'styled-components';

import DistributionCentersImage from '../../../containers/assets/onboarding-distribution-centers.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;
`;

const Container = styled.div`
  padding: 40px;
  width: 80%;
  max-width: 794px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  p {
    margin-bottom: 8px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  a {
    color: #5c91f5;
  }
`;

const Image = styled.div`
  display: flex;
  margin-top: 12px;

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }
`;

class DistributionCenters extends PureComponent {

  render() {
    return (
      <Wrapper>
        <Container>
          <Text1>What to expect</Text1>
          <Text2>Distribution Centers</Text2>
          <Text3>
            <p>You currently have 1 central location that you use to deliver your products to customers: your production facility. You’ll now have the option to open up a distribution center that could help reduce your lead time and thereby capture more customers if your lead time is better.</p>
          </Text3>

          <Image>
            <img src={DistributionCentersImage} alt="" />
          </Image>
        </Container>
      </Wrapper>
    );
  }

}

export default DistributionCenters;



// WEBPACK FOOTER //
// ./src/components/onboarding/what-to-expect/DistributionCenters.js